<template>
    <div class="apprentice-simple-card">
        <div class="row">
            <div class="col-12">
                <p>
                    {{ $t('digital_studies.dear_teacher') }}<br /><br />
                    {{
                        $t(
                            'digital_studies.through_this_i_know_it_better_button_you_can_help_us_improve_digital_studies',
                        )
                    }}<br />
                    {{ $t('digital_studies.we_are_always_open_to_feedback_and_could_use_your_help') }}<br />
                    {{ $t('digital_studies.video_feedback_invitation') }}<br /><br />
                    {{ $t('digital_studies.feedback_reward_offer') }}<br /><br />
                    {{ $t('digital_studies.feedback_invitation') }}<br /><br />
                    {{ $t('digital_studies.thank_you_for_your_interest_we_really_appreciate_it') }}
                </p>

                <hr />

                <design-2021-digistudies-feedback-contact-form
                    :user="userIn"></design-2021-digistudies-feedback-contact-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-digistudies-improve-component',
    props: ['userIn'],
};
</script>

<style scoped></style>
